import request from 'superagent';
import { hashHistory } from 'react-router';

import utils from './utilities';
import reduxStore from './../reduxStore';

import errorMessagesActions from './../reusable/MessagePopup/redux/MessagePopup.actions';
import storage from "./storage";

let xhr = {


     printCallStack: function() {
        var stack = new Error().stack;
        console.error("PRINTING CALL STACK");
        console.error( stack );
    },

    /**
     * An XHR error handler to call in case uniform treatment of all errors is needed.
     *
     * @param   {Object} error   The XHR error object.
     * @return  nothing
     */
    handleAllErrors: function (error) {

        xhr.printCallStack();
        console.error("handleAllErrors : ");
        console.error(error);

        // Route in case of errors
        switch (error.status) {

            case 400:
                errorMessagesActions.setMessages({
                    messages: [
                        {
                            titleId:     'General_CoreFunctionality_Error_error.400Title',
                            messageType: 'system-error',
                            messageId:   'General_CoreFunctionality_Error_error.400Title'
                        }
                    ]
                });
                break;

            case 401:
                reduxStore.dispatch(
                    {
                        type:    "USER_INFO_FAIL",
                        payload: error.response.body
                    }
                );

                utils.clearUserSession();

                console.log("================ ", window.location.hash);

                let auth = storage.getObject("lnei");
                if (auth && auth.serverInfo) {
                    // redirect to WAM
                    window.location = auth.serverInfo.wamLogin + "?back=" + encodeURIComponent(auth.serverInfo.customerUi) + "&aci=" + auth.serverInfo.wamAciCode;
                }

                return;

            case 403:
                errorMessagesActions.setMessages({
                    messages: [
                        {
                            titleId:     'General_CoreFunctionality_Error_error.forbiddenTitle',
                            messageType: 'system-error',
                            messageId:   'General_CoreFunctionality_Error_error.forbiddenMessage'
                        }
                    ]
                });
                break;

            case 404:
                errorMessagesActions.setMessages({
                    messages: [
                        {
                            titleId:     'General_CoreFunctionality_Error_error.404Title',
                            messageType: 'system-error',
                            messageId:   'General_CoreFunctionality_Error_error.404Message'
                        }
                    ]
                });
                break;

            default:
            {
                errorMessagesActions.setMessages({
                    messages: [
                        {
                            titleId:     'General_CoreFunctionality_Error_error.500Title',
                            messageType: 'system-error',
                            messageId:   'General_CoreFunctionality_Error_error.500Message'
                        }
                    ]
                });
            }

        }

        hashHistory.push('/error');

    },

    /**
     * Make XHR call.
     *
     * @param   {string}  params.method    Can be "POST" or "GET".
     * @param   {string}  params.url       The request URL.
     * @param   {Object}  params.data      The XHR call parameters.
     * @param   {string}  params.headers   The request headers.
     * @param   {Array}   params.files     Files that will be sent along with the request. This array contains objects
     *                                     with the following format: {name: 'fileFieldName', content: new File()}.
     * @param   {number}  params.timeout   The request timeout interval specified in ms. Default: 60 seconds
     * @param   {string}  params.error     Callback which gets executed if the request fails.
     * @param   {string}  params.success   Callback which gets executed if the request succeeds.
     * @return  {Promise}                  The promise which wraps the XHR call.
     */
    call: function(params) {

        return new Promise(function(resolve, reject) {

            let method = params.method ? params.method.toLowerCase() : 'get';

            // Specify the method and URL
            let req = request[method](params.url);

            // Set the headers if present
            if (utils.isObject(params.headers)) {
                req = req.set(params.headers);
            }

            // Add the request parameters if present (either as query
            // string in the URL or as POST response body parameters)
            if (params.data) {

                let dataSendMethod = method === 'get' || method === 'head' ? 'query' : 'send';
                req = req[dataSendMethod](params.data);

            }

            // In case the user wants to add query params to a POST, PUT or DELETE
            if (params.queryParams) {
                req = req.query(params.queryParams);
            }

            // Treat multipart file upload requests
            if (utils.isArray(params.files)) {
                for (let i = 0; i < params.files.length; i++) {

                    let file = params.files[i];

                    if (utils.isObject(file) && typeof file.name === 'string' && file.content) {

                        req = req.attach(file.name, file.content);

                    }

                }
            }

            // Add timeout if specified
            if (typeof params.timeout === 'number' && params.timeout >= 1) {
                req = req.timeout(parseInt(params.timeout, 10));
            } else {
                req = req.timeout(60000); // Default timeout is 60 seconds
            }

            if (!utils.isUserSessionValid()) {
                utils.clearUserSession();
            }

            // Send the request
            req.end(function(error, response) {

                if (error || !response.ok) {

                    error = error ? error : response;
                    return reject(error);

                } else if (response.ok) {

                    return resolve(response);

                }

            });


        });

    },

    /**
     * Make GET XHR call.
     *
     * @param   {string}  params.url       The request URL.
     * @param   {string}  params.data      The XHR call parameters.
     * @param   {string}  params.headers   The request headers.
     * @param   {number}  params.timeout   The request timeout interval specified in ms. Default: 60 seconds.
     * @return  {Promise}                  The promise which wraps the XHR call.
     */
    get: function(params) {

        params.method = 'get';
        return xhr.call(params);

    },

    /**
     * Make POST XHR call.
     *
     * @param   {string}  params.url           The request URL.
     * @param   {string}  params.data          The XHR call parameters.
     * @param   {string}  params.headers       The request headers.
     * @param   {Object}  params.queryParams   Query params to be sent along with the request.
     * @param   {Array}   params.files         Files that will be sent along with the request. This array contains
     *                                         objects with the format: {name: 'fileFieldName', content: new File()}.
     * @param   {number}  params.timeout       The request timeout interval specified in ms. Default: 60 seconds.
     * @return  {Promise}                      The promise which wraps the XHR call.
     */
    post: function(params) {

        params.method = 'post';
        return xhr.call(params);

    },

    /**
     * Make PUT XHR call.
     *
     * @param   {string}  params.url           The request URL.
     * @param   {string}  params.data          The XHR call parameters.
     * @param   {string}  params.headers       The request headers.
     * @param   {Object}  params.queryParams   Query params to be sent along with the request.
     * @param   {Array}   params.files         Files that will be sent along with the request. This array contains
     *                                         objects with the format: {name: 'fileFieldName', content: new File()}.
     * @param   {number}  params.timeout       The request timeout interval specified in ms. Default: 60 seconds.
     * @return  {Promise}                      The promise which wraps the XHR call.
     */
    put: function(params) {

        params.method = 'put';
        return xhr.call(params);
    },

    /**
     * Make HEAD XHR call.
     *
     * @param   {string}  params.url       The request URL.
     * @param   {string}  params.headers   The request headers.
     * @param   {number}  params.timeout   The request timeout interval specified in ms. Default: 60 seconds.
     * @return  {Promise}                  The promise which wraps the XHR call.
     */
    head: function(params) {

        params.method = 'head';
        return xhr.call(params);
    },

    /**
     * Make DELETE XHR call.
     *
     * @param   {string}  params.url           The request URL.
     * @param   {string}  params.data          The XHR call parameters.
     * @param   {string}  params.headers       The request headers.
     * @param   {Object}  params.queryParams   Query params to be sent along with the request.
     * @param   {number}  params.timeout       The request timeout interval specified in ms. Default: 60 seconds.
     * @return  {Promise}                      The promise which wraps the XHR call.
     */
    delete: function(params) {

        params.method = 'del';
        return xhr.call(params);

    }

};

export default xhr;


// WEBPACK FOOTER //
// ./src/scripts/utils/xhr.js